import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import styles from './switchpageitem.module.scss';

type SwitchDirection = 'prev' | 'next';

interface Props {
  pageNumber: number;
  direction: SwitchDirection;
  handleChangePage: (pageNumber: number) => void;
  useXsView?: boolean;
}

const SwitchPageItem = ({ pageNumber, direction, handleChangePage, useXsView }: Props) => {
  // handlers
  const changePageHandler = () => {
    handleChangePage(pageNumber);
  }

  // helpers
  const getXsClass = () => {
    if (useXsView) {
      return ` ${styles.xs}`;
    } else {
      return "";
    }
  }
  
  // sub-renders
  const renderIcon = () => {
    switch (direction) {
      case "prev":
        return <FontAwesomeIcon icon="chevron-left" size="sm" />
      case "next":
        return <FontAwesomeIcon icon="chevron-right" size="sm" />
      default:
        return null;
    }
  }

  // render
  return (
    <li className="page-item">
      <button className={`page-link ${styles.switchPageBtn}${getXsClass()}`} onClick={changePageHandler}>
        {renderIcon()}
      </button>  
    </li>
  )
}

export default SwitchPageItem;
